export const VERSION_MANAGEMENT_DEFAULT = 'system-default';
